export default __webpack_public_path__ + "static/media/shalat.f470db85.png";